import { Navigate, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { LoginPanel } from "@/components/AuthPanel";
import { PrivacyNotice } from "@/components/Fields";

export default function SignIn() {
  const { user, t, lang, setLang } = useApp();
  const nav = useNavigate();
  if (user) return <Navigate to="/" replace />;
  return (
    <div className="mx-auto min-h-screen max-w-md bg-[#F4F8F5] px-6 pb-10 pt-6">
      <div className="flex justify-end">
        <button onClick={() => setLang(lang === "en" ? "hi" : "en")} data-testid="login-lang-toggle"
          className="rounded-full border border-[#D2E0D8] bg-white px-3 py-1 text-sm font-semibold text-[#0D3B2B]">{lang === "en" ? "हिंदी" : "English"}</button>
      </div>
      <div className="ks-rise space-y-6">
        <img src="/logo-full.png" alt="Kindsaver - Kind. Clean. Bold." className="mx-auto mt-6 w-64" data-testid="login-logo" />
        <div className="text-center">
          <h1 className="font-display text-3xl font-extrabold text-[#0D3B2B]">{t("Log in")}</h1>
          <p className="mt-1 text-sm text-[#4A6358]">{t("See your pickups, impact and rank.")}</p>
        </div>
        <LoginPanel afterPath="/" onDone={() => nav("/", { replace: true })} />
        <button onClick={() => nav("/book")} className="h-12 w-full font-semibold text-[#2E9E6B]" data-testid="login-book-first-btn">{t("Book a pickup first")}</button>
        <PrivacyNotice />
      </div>
    </div>
  );
}
